module.exports = __webpack_public_path__ + "static/media/galerija_2013 (11).e806eb57.JPG";